// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TooltipType;
(function (TooltipType) {
    TooltipType[TooltipType["Connection"] = 0] = "Connection";
    TooltipType[TooltipType["Trade"] = 1] = "Trade";
    TooltipType[TooltipType["Refuse"] = 2] = "Refuse";
    TooltipType[TooltipType["Chat"] = 3] = "Chat";
    TooltipType[TooltipType["RunTradingSystem"] = 4] = "RunTradingSystem";
    TooltipType[TooltipType["StopTradingSystem"] = 5] = "StopTradingSystem";
    TooltipType[TooltipType["System"] = 6] = "System";
    TooltipType[TooltipType["Idea"] = 7] = "Idea";
    TooltipType[TooltipType["AccountOperation"] = 8] = "AccountOperation";
    TooltipType[TooltipType["CAInfo"] = 9] = "CAInfo";
    TooltipType[TooltipType["CAAccepted"] = 10] = "CAAccepted";
    TooltipType[TooltipType["CARejected"] = 11] = "CARejected";
    TooltipType[TooltipType["CACanceled"] = 12] = "CACanceled";
    TooltipType[TooltipType["FollowerInfo"] = 13] = "FollowerInfo";
})(TooltipType || (TooltipType = {}));
export const TooltipTypeName = Object.keys(TooltipType);
